import React from 'react';
import { ArServiceContextProvider } from './AccountsReceivableServiceContext';
import IccoBreakdownPage from './IccoBreakdownPage';
const IccoBreakdownComponent = () => {
  return (
    <ArServiceContextProvider>
      <IccoBreakdownPage />
    </ArServiceContextProvider>
  );
};
export default IccoBreakdownComponent;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/IccoBreakdownComponent.tsx